import { UIButton, UICheckButton, UIControl, UILabel, UIViewController, UIView } from "uikit";
import { BookingProductReviewViewController } from "./BookingProductReviewViewController";
import { BookingClientViewController } from "./BookingClientViewController";
import { BookingExtrasViewController } from "./BookingExtrasViewController";
import { DLDB, RIGHTS_URL } from "dldb";
import { NSLocalizeString } from "foundation";
import { MIOStringWithFormat } from "mio-core";
import { AdyenPaymentViewController } from "./AdyenPaymentViewController";
import { BookingSummaryViewController } from "./BookingSummaryViewController";
import { MIOCoreGetPlatformLanguage } from "mio-core";
import { IBook } from "dldb";

export class BookingReviewViewController extends UIViewController
{        
    private productReviewView: UIView = null;
    private extrasView: UIView = null;
    private clientView: UIView = null;
    
    protected errorLbl        : UILabel       = null ;

    private acceptTermsCB     : UICheckButton = null ;
    private acceptPrivacyCB   : UICheckButton = null ;
    private acceptPublicityCB : UICheckButton = null ;
    private acceptTermsLbl    : UILabel       = null ;
    private acceptPrivacyLbl  : UILabel       = null ;
    
    private bookButton: UIButton = null;
    private backButton: UIButton = null;


    viewDidLoad() {
        super.viewDidLoad();

        if ( DLDB.shared.cart().showExtrasController() ) {
            let extrasViewController = new BookingExtrasViewController();
            extrasViewController.initWithNibName("BookingExtrasView");
            this.extrasView.addSubview( extrasViewController.view );
            this.addChildViewController( extrasViewController );
        }
        else {
            this.extrasView.hidden = true;
        }

        let productReviewViewController = new BookingProductReviewViewController();
        productReviewViewController.initWithNibName("BookingProductReviewView");
        this.productReviewView.addSubview( productReviewViewController.view );
        this.addChildViewController( productReviewViewController );

        let clientReviewViewController = new BookingClientViewController();
        clientReviewViewController.initWithNibName("BookingClientView");
        this.clientView.addSubview( clientReviewViewController.view );
        this.addChildViewController( clientReviewViewController );

        if ( this.acceptPrivacyLbl )
             this.acceptPrivacyLbl.text = MIOStringWithFormat( NSLocalizeString( "ACCEPT PRIVACY", "ACCEPT PRIVACY" ), DLDB.shared.getURL( RIGHTS_URL.PRIVACY ) ) ;
             
        if ( this.acceptTermsLbl )
             this.acceptTermsLbl.text = MIOStringWithFormat( NSLocalizeString( "ACCEPT TERMS", "ACCEPT TERMS" ), DLDB.shared.getURL( RIGHTS_URL.TERMS ) ) ;

        if ( this.acceptTermsCB )
            this.acceptTermsCB.addTarget( this, this.checkBookBtn, UIControl.Event.touchUpInside );

        if ( this.acceptPrivacyCB)
            this.acceptPrivacyCB.addTarget( this, this.checkBookBtn, UIControl.Event.touchUpInside );

        if ( this.acceptPublicityCB)
            this.acceptPublicityCB.addTarget( this, this.checkBookBtn, UIControl.Event.touchUpInside );

        this.errorLbl.setHidden( true ) ;

        this.backButton.addTarget(this, this.onBack, UIControl.Event.touchUpInside);
        
        this.bookButton.addTarget(this, this.onBook, UIControl.Event.touchUpInside);
        this.bookButton.enabled = false;
    }

    checkBookBtn = ( dryRun: boolean = false ) => {
        const bookBtn = this.bookButton ;

       if ( bookBtn )
            bookBtn.enabled =  this.acceptTermsCB.on
                            && this.acceptPrivacyCB.on ;
    }

    onBook() {
        const products = DLDB.shared.cart().lines.length > 0 ?
            DLDB.shared.cart().lines.map(l => ({ productID: l.productID, quantity: l.quantity })) :
            [];

        let b: IBook = {
            id: DLDB.shared.booking().id.UUIDString,
            pax: DLDB.shared.cart().totalQuantity,
            zoneID: null,
            timeID: DLDB.shared.cart().time,
            date: DLDB.shared.cart().date,
            comments: DLDB.shared.cart().comments,
            client: {
                name: DLDB.shared.cart().name,
                phone: DLDB.shared.cart().phone,
                email: DLDB.shared.cart().email,
            },
            acceptTerms: this.acceptTermsCB.on,
            acceptPrivacy: this.acceptPrivacyCB.on,
            acceptPublicity: this.acceptPublicityCB.on,
            language: MIOCoreGetPlatformLanguage()
        };

        if (products.length > 0) {
            b.products = products;
        }

        this.bookButton.enabled = false;
        DLDB.shared.book( b, ( code, json ) => {
            this.bookButton.enabled = true;
            if ( code === 200 && json["error"] == null )
            {
                if ( json.data["PaymentFields"] != null ) {

                    let vc = new AdyenPaymentViewController();
                    vc.initWithNibName( "AdyenPaymentView" );
                    vc.setPaymentFields( json.data["PaymentFields"] );
                    this.presentViewController(vc, true);
                }
                else {
                    const vc = BookingSummaryViewController.newInstance( true );
                    this.presentViewController(vc, true);
                }
            }
            else 
            {
                let error = (json.error || "").replace( "[BookingApiError] ", "" );
                this.errorLbl.text = NSLocalizeString(error, error) ;
                this.errorLbl.setHidden( false ) ;
            }
        } );
    }

    onBack() {
        this.dismissViewController(true);
    }
}